import script from "./MyProfileContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProfileContent.vue?vue&type=script&setup=true&lang=js"

import "./MyProfileContent.vue?vue&type=style&index=0&id=686124ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-686124ab"]])

export default __exports__